import { render, staticRenderFns } from "./AdminLinksModal.vue?vue&type=template&id=a407bf36&scoped=true&"
import script from "./AdminLinksModal.vue?vue&type=script&lang=ts&"
export * from "./AdminLinksModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a407bf36",
  null
  
)

export default component.exports